import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a ParallelJoin task — waits for all upstream parallel branches
 * to deliver their payloads, then merges them. The first branch to arrive acquires a
 * mutex and collects the rest via a queue; non-collecting branches exit silently.
 * Merge shape is controlled by flatJoin.
 */
export class ParallelJoinConfig extends DestinationTaskConfigBase {
	/**
	 * Maximum time in seconds to wait for all branches to arrive. If the timeout
	 * expires and continueOnPartialComplete=false, the task throws an error.
	 * @default 60
	 */
	waitTime: number = 60;

	/**
	 * When false (default), produces one record whose processingData has each branch
	 * task name as a key containing an array of that branch's processingData values.
	 * When true, all branch records are concatenated into a flat records array.
	 * @default false
	 */
	flatJoin: boolean = false;

	/**
	 * When true, the join proceeds with partial results if waitTime expires before
	 * all branches arrive. When false (default), a timeout throws an error.
	 * @default undefined (falsy)
	 */
	continueOnPartialComplete?: boolean;

	constructor(init?: Partial<ParallelJoinConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
